// extracted by mini-css-extract-plugin
export default {"zoomModal":"x1-z"};